
export class ProductFull {
	productId: number;
	coverageId: number;
	productPolicyId: number;
	priceBookId: number;
	productName: string;
	coverageName: string;
}